// src/api/branches.js
import API from "../api.js";

// Fetch all active branches
export function fetchBranches() {
  return API.get("/admin/branches");
}

// Fetch one branch by ID
export function fetchBranch(id) {
  return API.get(`/admin/branches/${id}`);
}

// Create a new branch
export function createBranch(data) {
  return API.post("/admin/branches", data);
}

// Update an existing branch
export function updateBranch(id, data) {
  return API.put(`/admin/branches/${id}`, data);
}

// Archive (delete) a branch
export function archiveBranch(id) {
  return API.delete(`/admin/branches/${id}`);
}

// Reactivate a branch
export function activateBranch(id) {
  return API.patch(`/admin/branches/${id}/activate`);
}
